import { xs_languageCode } from "..";
import { getMainAgg } from "./utils/getMainAgg";
import { parseBetsData } from "./parseBetsData";
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getDBTimestampFromDate } from './utils/getDBTimestampFromDate';

export function parseAgendaStreamingData(data) {
    if (data.agenda == null) {
        return [];
    }
    
    const agenda = JSON.parse(data.agenda);
    const started = data.started?JSON.parse(data.started) : null;
    const agendaStreamingSports = {};

    agenda.ms && Object.values(agenda.ms).forEach(function(match) {
        const sportId = match.is;
        let asSport = agendaStreamingSports[sportId];
        if (asSport === undefined) {
            asSport = {
                sportId: sportId, 
                sportDesc: agenda.sds[sportId][xs_languageCode], 
                iconClassSport: agenda.icos && agenda.icos[sportId],
                tournamentsById: {}, 
                countriesById: {}, 
                earlierTs: null,
                eventsCount: 0,
                eventsCountStarted: 0,
                eventsCountNotStarted: 0,
                rk: agenda.spr?.[sportId]
            };
            agendaStreamingSports[sportId] = asSport;
        }

        const tournamentId = match.it
        let asTournament = agendaStreamingSports[sportId].tournamentsById[tournamentId];
        if (asTournament == null) {
            asTournament = {
                tournamentId: tournamentId, 
                tournamentDesc: agenda.tds[tournamentId][xs_languageCode], 
                sportRef: sportId,
                categoryRef: match.ic,
                iconClassSport: agenda.icos && agenda.icos[sportId],
                iconClassCountry: agenda.icoc && agenda.icoc[match.ic],
                matchesById: {},
                earlierTs: null,
                eventsCount: 0,
                eventsCountStarted: 0,
                eventsCountNotStarted: 0,
                rk: agenda.tnr?.[tournamentId]
            };
            agendaStreamingSports[sportId].tournamentsById[tournamentId] = asTournament;
        }
       

        const countryId = match.ic
        let asCountry = agendaStreamingSports[sportId].countriesById[countryId];
        if (asCountry == null) {
            asCountry = {
                countryId: countryId, 
                countryDesc: agenda.cds[countryId][xs_languageCode], 
                sportRef: sportId,
                iconClassSport: agenda.icos && agenda.icos[sportId],
                iconClassCountry: agenda.icoc && agenda.icoc[match.ic],
                matchesById: {},
                earlierTs: null,
                eventsCount: 0,
                eventsCountStarted: 0,
                eventsCountNotStarted: 0,
                tournamentsCount: 0,
                rk: agenda.ctr?.[countryId]
            };
            agendaStreamingSports[sportId].countriesById[countryId] = asCountry;
        }

        const matchId = match.bid
        let asMatch = asTournament.matchesById[matchId];

        if (asMatch === undefined) {
            const _date = formatDate(match.ts);
            const timestamp = new Date(_date.year,_date.month-1,_date.day,_date.hours,_date.minutes,_date.seconds);
            const strStarted = started?.ms?.[`${match.p}_${match.a}`]?.str ?? null;
            const strOver = (timestamp < (new Date())) && !strStarted;

            const desc = match.dsl[xs_languageCode];
            const split = desc && desc.split(' - ');
            asMatch = {
                ...match,
                matchId: matchId,
                id: match.bid,
                pal: match.p,
                avv: match.a,
                uniqueId: `${sportId}_${countryId}_${tournamentId}_${match.bid}`,
                desc: desc,
                team1: split && split[0],
                team2: split && split[1],
                date: _date,
                str: strStarted,
                strOver: strOver,
                timestamp: timestamp,
                iconClassSport: agenda.icos && agenda.icos[sportId],
                iconClassCountry: agenda.icoc && agenda.icoc[match.ic],
                sportRef: sportId,
                categoryRef: match.ic,
                tournamentRef: match.it,
                sportDesc: asSport.sportDesc,
                categoryDesc: asCountry.countryDesc,
                tournamentDesc: asTournament.tournamentDesc
            };
            if (strStarted) {
                const startedMatch = started?.ms?.[`${match.p}_${match.a}`];
                asMatch.scs =  startedMatch?.scs ;
                asMatch.alias = startedMatch?.al;
            }
            if (asMatch.scs) {
                const mainAggr = getMainAgg(true, sportId);
                asMatch={...asMatch,
                        ...parseBetsData(asMatch, [mainAggr?.idAggregata], mainAggr.idAggregata, asMatch.scs, true, true),
                        aggregata: mainAggr?.idAggregata
                    }
            }
            asTournament.matchesById[matchId] = asMatch;

            if (asTournament.earlierTs === null || (asTournament.earlierTs > timestamp)) {
                if (!strOver) {
                    asTournament.earlierTs = timestamp
                }
            }
            
            if (asSport.earlierTs === null || (asSport.earlierTs > timestamp)) {
                if (!strOver) {
                    asSport.earlierTs = timestamp
                }
            }
        }

        if (!asMatch?.strOver) {
            asSport.eventsCount = asSport.eventsCount+1;
            asTournament.eventsCount = asTournament.eventsCount+1;
            asCountry.eventsCount = asCountry.eventsCount+1;
            if (asMatch.str) {
                asSport.eventsCountStarted = asSport.eventsCountStarted+1;
                asTournament.eventsCountStarted = asTournament.eventsCountStarted+1;
                asCountry.eventsCountStarted = asCountry.eventsCountStarted+1;
            } else {
                asSport.eventsCountNotStarted = asSport.eventsCountNotStarted+1;
                asTournament.eventsCountNotStarted = asTournament.eventsCountNotStarted+1;
                asCountry.eventsCountNotStarted = asCountry.eventsCountNotStarted+1;
            }

            if (asTournament.categoryRef == countryId) {
                asCountry.tournamentsCount =  asCountry.tournamentsCount+1;
            }
        }
    });

    Object.entries(agendaStreamingSports).forEach(function([ks, vs]) {
        Object.entries(agendaStreamingSports[ks].tournamentsById).forEach(function([kt, vt]) {
            vt.hasMatches = Object.values(vt.matchesById).find(m => !m.strOver) != null;
            vt.hasMatchesStarted = Object.values(vt.matchesById).find(m => m.str != null) != null;
            vt.hasMatchesNotStarted = Object.values(vt.matchesById).find(m => m.str == null) != null;
            if (vt.hasMatches) {
                vs.hasTournaments = true;
            }
            vs.tournamentsById = Object.values(vs.tournamentsById).sort((a, b) => a.earlierTs - b.earlierTs);
            vs.countriesById = Object.values(vs.countriesById).sort((a, b) => a.earlierTs - b.earlierTs);

            vt.matchesById = Object.values(vt.matchesById).sort((a, b) => a.timestamp - b.timestamp);
        });
    });

    const asSorted = Object.values(agendaStreamingSports).sort((a, b) => a.earlierTs - b.earlierTs);

    return asSorted;
}

export function parseAgendaStreamingDataByDate(data) {
    const sports = parseAgendaStreamingData(data);

    const dates = new Map();
    sports.forEach(s => {
        if (s.earlierTs == null) {
            return;
        }
        
        const date = s.earlierTs.getDate();
        if (!dates.has(date)) {
            const timestamp = getDBTimestampFromDate(s.earlierTs);
            s.formattedDate = formatDateWithWeekDay(timestamp).day;
            dates.set(date, []);
        }
        dates.get(date).push(s);
    });

    return Array.from(dates.values());
}
